export const ANIMATE_IMAGE_PROMPT_MAX_LENGTH = 1000;
export const ANIMATE_IMAGE_PROMPT_NAME_MAX_LENGTH = 80;
export const ANIMATE_IMAGE_OUTRO_NAME_MAX_LENGTH = 80;
export const ANIMATE_IMAGE_OUTRO_ACCEPT =
  "video/mp4,video/quicktime,video/webm,.mp4,.mov,.webm";
